/* tslint:disable */
/* eslint-disable */
/**
 * Bonds API
 * Microservice backend for bond management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InvestorReturnStateEnum {
    Paid = 'paid',
    Unpaid = 'unpaid',
    Unknown = 'unknown',
    Pending = 'pending',
    Future = 'future'
}


export function InvestorReturnStateEnumFromJSON(json: any): InvestorReturnStateEnum {
    return InvestorReturnStateEnumFromJSONTyped(json, false);
}

export function InvestorReturnStateEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestorReturnStateEnum {
    return json as InvestorReturnStateEnum;
}

export function InvestorReturnStateEnumToJSON(value?: InvestorReturnStateEnum | null): any {
    return value as any;
}

